import { AiOutlineMenu } from "react-icons/ai";
import { LOGO } from "../../assets";

import { Link } from "react-router-dom";
import "../../index.css";
import { selectRole } from "../../states/slices/authReducer";
import { useAppSelector } from "../../hooks";
import Api from "../../config";
import { getFormDataHeader, getJSONheader } from "../../utils";
import { useEffect, useState } from "react";
import { useGetPaymentsQuery } from "../../services/apis/cases";
import PendingPaymentsModal from "../modals/PendingPaymentsModal";
import { Payment } from "../../types";

interface header {
  onMenu?: any;
  handleShowFilter?: any;
}

function Header(props: header) {
  const role = useAppSelector(selectRole);
  const [showPendingPayments, setShowPendingPayments] = useState(false);
  const [paymentsData, setPaymentsData] = useState<Payment[]>([]);
  const [isLoadingPayments, setIsLoadingPayments] = useState(false);
  //   const { data: paymentsData, isLoading: isLoadingPayments } =
  //     useGetPaymentsQuery(null, {
  //       selectFromResult: ({ data, isLoading }) => ({
  //         data: data?.data || [],
  //         isLoading,
  //       }),
  //     });

  const handleGetPayments = async () => {
    setIsLoadingPayments(true);
    try {
      const response = await Api.get("/payments", getJSONheader());
      if (response) {
        setPaymentsData(response.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingPayments(false);
    }
  };

  useEffect(() => {
    handleGetPayments();
  }, []);

  const pendingPaymentsCount =
    paymentsData?.filter(
      (payment: Payment) =>
        payment.status === "pending" ||
        payment.service?.payment_status === "pending",
    ).length || 0;

  return (
    <div>
      <div
        className={`${
          role !== "LAWYER" ? "h-[12vh]" : "h-[16vh]"
        } flex justify-between bg-white border-b-brand_blue border-b-8 items-center flex-row w-full px-4 lg:px-8 pt-8 lg:pt-0 pb-4 lg:py-2`}
      >
        <div className="hidden lg:flex lg:flex-1 items-center gap-x-5 mr-3 "></div>
        <div className="flex flex-1 lg:flex-none shrink-0 gap-x-3 items-center h-full justify-start ">
          <Link
            to="/"
            className={`transition ease-in-out delay-150 py-2 px-3 w-16 flex justify-between items-center  hover:-translate-y-1 hover:scale-110  duration-300 text-xs `}
          >
            <img
              src={LOGO}
              className="h-full w-full rounded-full"
              alt="...logo"
            />
          </Link>

          {/* Pending Payments Button */}
          {/* {role === "LAWYER" && (
            <button
              onClick={() => setShowPendingPayments(true)}
              className="relative p-2 text-gray-600 hover:text-blue-600 transition-colors duration-200"
              title="Pending Payments"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
              {pendingPaymentsCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                  {pendingPaymentsCount}
                </span>
              )}
            </button>
          )} */}
        </div>
        {/* {role === "LAWYER" && (
          <div className="py-2 h-full text-gray-500 text-xs flex justify-between">
            <div className=" h-4 w-4 animate-ping rounded-full bg-brand_blue/70"></div>
            <div>
              <p className="text-black font-bold">
                Rivers State Family Revenue Account
              </p>
              <p className="text-black font-bold">Account Number: 1130100273</p>
              <p className="">Branch: Port Harcourt Main Branch</p>
              <p className="">Swift Code: ZEIBNGLA.</p>
              <p>Zenith Bank Plc</p>
            </div>
          </div>
        )} */}
        <div className="lg:hidden">
          <AiOutlineMenu onClick={props.onMenu} className="h-10 text-4xl" />
        </div>
      </div>
      <PendingPaymentsModal
        open={showPendingPayments}
        onClose={() => setShowPendingPayments(false)}
        payments={paymentsData || []}
        isLoading={isLoadingPayments}
      />
    </div>
  );
}

export default Header;
